import { considerationToDimension } from '../../../constants/Constants'
import {
  StoreData,
  getDimensionName,
  getConsiderationName,
} from '../getPageContext'

export const buildCityScoresContent = (
  data?: StoreData
): Record<string, unknown> => {
  if (!data?.allInfo) return {}

  const { allInfo, drawerOpen, drawerConsideration, locale } = data

  // Build dimensions with their considerations
  const dimensionMap: Record<
    number,
    {
      name: string
      score: number
      considerations: { name: string; score: number }[]
    }
  > = {}

  for (const dim of allInfo.LatestCityDimensions) {
    dimensionMap[dim.id] = {
      name: getDimensionName(dim.id, dim.name, locale),
      score: Math.round(dim.value),
      considerations: [],
    }
  }

  for (const c of allInfo.LatestCityConsiderations) {
    const meta = considerationToDimension[c.id] as
      | { dimension: number }
      | undefined
    const dimEntry = meta
      ? (dimensionMap as Partial<typeof dimensionMap>)[meta.dimension]
      : undefined
    if (meta && dimEntry) {
      dimEntry.considerations.push({
        name: getConsiderationName(c.id, c.name, locale),
        score: Math.round(c.value),
      })
    }
  }

  const dimensions = Object.values(dimensionMap).map((dim) => ({
    ...dim,
    considerations: dim.considerations.sort((a, b) => b.score - a.score),
  }))

  // Build open consideration with indicators if drawer is open
  let openConsideration: Record<string, unknown> | null = null
  if (drawerOpen && drawerConsideration) {
    const cId = Number(drawerConsideration)
    const consideration = allInfo.LatestCityConsiderations.find(
      (c) => c.id === cId
    )
    const meta = considerationToDimension[cId] as
      | { dimension: number }
      | undefined

    if (consideration && meta) {
      const weights = allInfo.LatestCityIndicatorWeights.filter(
        (w) => w.c === cId
      )
      const indicators = weights
        .map((w) => {
          const ind = allInfo.LatestCityIndicators.find((i) => i.id === w.i)
          if (!ind) return null
          return {
            name: ind.name,
            value: Math.round(ind.value * 100) / 100,
            measure: ind.measure,
          }
        })
        .filter(
          (item): item is { name: string; value: number; measure: string } =>
            item !== null
        )
        .sort((a, b) => (a.name > b.name ? 1 : -1))

      openConsideration = {
        name: getConsiderationName(cId, consideration.name, locale),
        dimension: getDimensionName(meta.dimension, undefined, locale),
        score: Math.round(consideration.value),
        indicators,
      }
    }
  }

  return {
    selectedQuarter: data.selectedQuarter,
    dimensions,
    openConsideration,
  }
}
